import React from "react";
import Banner from "../components/Banner/Banner";
import CoinsTable from "../components/CoinsTable";
// import CoinsTable from "./CoinsTablecopycopy";
const HomePage = () => {
  return (
    <>
      <Banner />
      <CoinsTable />
    </>
  );
};

export default HomePage;
